import { ComponentPropsWithRef, forwardRef } from "react";
import transWidthHeight from "./utils/transWidthHeight";

export type FlexProps = ComponentPropsWithRef<"div"> & {
    flexDirection?: "row" | "column" | "row-reverse" | "column-reverse";
    justifyContent?: "start" | "center" | "end" | "space-between" | "space-around" | "space-evenly" | "flex-end" | "flex-start";
    alignItems?: "start" | "center" | "end" | "stretch" | "baseline" | "flex-end" | "flex-start";
    fullWidth?: boolean;
    fullHeight?: boolean;
    width?: number | string;
    height?: number | string;
    noWrap?: boolean;
    /* 
        flexWrap?: "nowrap" | "wrap" | "wrap-reverse";
        flexGrow?: number;
        flexShrink?: number;
        flexBasis?: number;
        flex?: number;
    */
    gap?: string | number;
    rowGap?: number;
    flexWrap?: "nowrap" | "wrap" | "wrap-reverse";
    overflow?: "hidden" | "visible" | "scroll" | "auto";
    overflowX?: "hidden" | "visible" | "scroll" | "auto";
    overflowY?: "hidden" | "visible" | "scroll" | "auto";
    padding?: number | string;
    paddingX?: number | string;
    paddingY?: number | string;
    paddingTop?: number | string;
    paddingBottom?: number | string;
    paddingLeft?: number | string;
    paddingRight?: number | string;
};

const Flex = forwardRef<HTMLDivElement, FlexProps>(function Flex(
    {
    children,
    flexDirection = "row",
    justifyContent,
    alignItems,
    fullWidth = false,
    fullHeight = false,
    width,
    height,
    noWrap = true,
    padding,
    paddingX,
    paddingY,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    overflow,
    overflowX,
    overflowY,
    gap,
    rowGap,
    flexWrap,
    style,
    className,
    ...props
}: FlexProps, ref) {
    const gapValue = gap !== undefined ? transWidthHeight(gap) : undefined;
    const rowGapValue = rowGap !== undefined ? `${rowGap}px` : undefined;
    const widthValue = fullWidth ? "100%" : width !== undefined ? transWidthHeight(width) : undefined;
    const heightValue = fullHeight ? "100%" : height !== undefined ? transWidthHeight(height) : undefined;
    const flexWrapValue = (noWrap ? "nowrap" : flexWrap) || "wrap";
    const overflowValue = overflow ? overflow : undefined;
    const overflowXValue = overflowX ? overflowX : overflowValue;
    const overflowYValue = overflowY ? overflowY : overflowValue;
    
    return (
        <div
            ref={ref}
            className={className}
            style={{
                display: "flex",
                flexDirection: flexDirection,
                justifyContent: justifyContent,
                alignItems: alignItems,
                ...(gapValue !== undefined && { gap: gapValue }),
                ...(rowGapValue !== undefined && { rowGap: rowGapValue }),
                flexWrap: flexWrapValue,
                width: widthValue,
                height: heightValue,
                overflowX: overflowXValue,
                overflowY: overflowYValue,
                paddingTop: transWidthHeight(paddingTop) ?? transWidthHeight(paddingY) ?? transWidthHeight(padding),
                paddingBottom: transWidthHeight(paddingBottom) ?? transWidthHeight(paddingY) ?? transWidthHeight(padding),
                paddingLeft: transWidthHeight(paddingLeft) ?? transWidthHeight(paddingX) ?? transWidthHeight(padding),
                paddingRight: transWidthHeight(paddingRight) ?? transWidthHeight(paddingX) ?? transWidthHeight(padding),
                ...style,
            }}
            {...props}
        >
            {children}
        </div>
    )
});

export default Flex;